import constants from "./constants";
import { fromJS, Map } from "immutable";
import moment from "moment/moment";
import React from "react";
import { format } from "date-fns";

/* TODO: SANITIZE */
export function renderHTML(src) {
  return {
    __html: src,
  };
}

export function removeFromSessionStorage(key) {
  if (key && window && sessionStorage) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.log("Could not remove from session storage " + err);
    }
  }
}

export function saveToLocalStorage(key, val, expirationMin) {
  if (val && key && window && localStorage) {
    try {
      if (expirationMin) {
        const expirationMS = expirationMin * 60 * 1000;
        const value = {
          value: JSON.stringify(val),
          timestamp: new Date().getTime() + expirationMS,
        };
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, JSON.stringify(val));
      }
    } catch (err) {
      console.log("Could not use local storage " + err);
    }
  }
  return null;
}

export function getFromSessionStorage(key) {
  if (key && global.window && global.sessionStorage) {
    try {
      return JSON.parse(global.sessionStorage.getItem(key));
    } catch (err) {
      console.log("Could not get from session storage " + err);
    }
  }
  return null;
}

export function saveToSessionStorage(key, val) {
  if (val !== undefined && val !== null && key && window && sessionStorage) {
    try {
      sessionStorage.setItem(key, JSON.stringify(val));
    } catch (err) {
      console.log("Could not use session storage " + err);
    }
  }
  return null;
}

export function saveReservationToStorage(key, values) {
  if (values === undefined) {
    return null;
  }
  Object.keys(values).map(hotelTicker => {
    values[hotelTicker].map(value => {
      value.endDate = moment(value.endDate).format("YYYY-MM-DD");
      value.startDate = moment(value.startDate).format("YYYY-MM-DD");
    });
  });
  saveToSessionStorage(key, values);
}

export function removeFromLocalStorage(key) {
  if (key && window && localStorage) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.log("Could not remove from local storage " + err);
    }
  }
}

export function getFromLocalStorage(key) {
  if (key && window && localStorage && localStorage.getItem(key)) {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      if (value && value.timestamp) {
        if (new Date().getTime() < value.timestamp) {
          return JSON.parse(value.value);
        }
        removeFromLocalStorage(key);
      } else {
        return value;
      }
    } catch (err) {
      console.log("Could not get from local storage " + err);
    }
  }
  return null;
}

export function buildImgUrl(path, height, width, placeholder) {
  const newRepositoryServer = window.__additionalData.MEDIA_ROOT_URL_NG;
  const oldRepositoryServer = window.__additionalData.MEDIA_ROOT_URL_NG_OLD;
  if (!path) {
    return placeholder;
  }
  const lastDotIndex = path.lastIndexOf(".");
  const filenameWithoutExtension = path.substr(0, lastDotIndex);
  const filenameExtension = path.substr(lastDotIndex);
  let urlThumbnail = path;

  if (filenameWithoutExtension.includes(newRepositoryServer) || filenameWithoutExtension.includes(oldRepositoryServer)) {
    const [protocol, , server, step1, entity, fileName] = filenameWithoutExtension.split("/");
    let size = width;
    switch (width) {
      case 1920:
        size = 2048;
      case 750:
        size = 768;
        break;
    }
    urlThumbnail = `${protocol}//${server}/generated/${step1}/${entity}/${fileName}-${size}.jpeg`;
  } else if (height && width) {
    urlThumbnail = `${filenameWithoutExtension}_${width}x${height}${filenameExtension}`;
  }
  return urlThumbnail;
}

function codePriority(code) {
  switch (code) {
    case constants.BOOKABLE_STATUS.AVAILABLE:
      return 1;
    case constants.BOOKABLE_STATUS.RESTRICTED:
      return 2;
    case constants.BOOKABLE_STATUS.UNAVAILABLE:
      return 3;
    default:
      return 100;
  }
}

/* Apply to Inventories and Accommodations */
export function sortByCode(itemA, itemB, property, descending) {
  const itemAProperty = codePriority(itemA.getIn && itemA.getIn(property));
  const itemBProperty = codePriority(itemB.getIn && itemB.getIn(property));
  if (typeof itemAProperty === "undefined" || itemAProperty === null) {
    return 1;
  }
  if (typeof itemBProperty === "undefined" || itemBProperty === null) {
    return -1;
  }
  if (itemAProperty === itemBProperty) {
    return 0;
  }
  if (descending) {
    return itemAProperty < itemBProperty ? 1 : -1;
  }
  return itemAProperty < itemBProperty ? -1 : 1;
}

export function ariElmentSortBy(itemA, itemB, property, statusProperty, descending) {
  const itemAProperty = itemA[property] || (itemA.get && itemA.get(property));
  const itemBProperty = itemB[property] || (itemB.get && itemB.get(property));
  const itemAStatusProperty = codePriority(itemA.getIn && itemA.getIn(statusProperty));
  const itemBStatusProperty = codePriority(itemB.getIn && itemB.getIn(statusProperty));

  if (itemAStatusProperty !== 1 || itemBStatusProperty !== 1) {
    if (typeof itemAStatusProperty === "undefined" || itemAStatusProperty === null) {
      return 1;
    }
    if (typeof itemBStatusProperty === "undefined" || itemBStatusProperty === null) {
      return -1;
    }
    if (itemAStatusProperty === itemBStatusProperty) {
      return 0;
    }
    if (descending) {
      return itemAStatusProperty < itemBStatusProperty ? 1 : -1;
    }
    return itemAStatusProperty < itemBStatusProperty ? -1 : 1;
  }

  if (typeof itemAProperty === "undefined" || itemAProperty === null) {
    return 1;
  }
  if (typeof itemBProperty === "undefined" || itemBProperty === null) {
    return -1;
  }
  if (itemAProperty === itemBProperty) {
    return 0;
  }
  if (descending) {
    return itemAProperty < itemBProperty ? 1 : -1;
  }
  return itemAProperty < itemBProperty ? -1 : 1;
}

export function sortBy(itemA, itemB, property, descending) {
  const itemAProperty = itemA[property] || (itemA.get && itemA.get(property));
  const itemBProperty = itemB[property] || (itemB.get && itemB.get(property));
  if (typeof itemAProperty === "undefined" || itemAProperty === null) {
    return 1;
  }
  if (typeof itemBProperty === "undefined" || itemBProperty === null) {
    return -1;
  }
  if (itemAProperty === itemBProperty) {
    return 0;
  }
  if (descending) {
    return itemAProperty < itemBProperty ? 1 : -1;
  }
  return itemAProperty < itemBProperty ? -1 : 1;
}

export function getRateDecimalsNoRounding(number) {
  const integer = Math.floor(number).toString();
  const strungNumber = number.toString();
  const result =
    integer.length === strungNumber.length
      ? "00"
      : strungNumber.substring(integer.length + 1).substr(0, 2);
  return result.length < 2 ? result + "0" : result;
}

export function getExchangeMultiplier(bookableCurrency, engineCurrency, currencyExchange) {
  const bookableCurrencyToBaseCurrencyRate =
    bookableCurrency === currencyExchange.get("currencyBase")
      ? 1
      : 1 / currencyExchange.get("prices").get(bookableCurrency);
  return engineCurrency === currencyExchange.get("currencyBase")
    ? bookableCurrencyToBaseCurrencyRate
    : bookableCurrencyToBaseCurrencyRate * currencyExchange.get("prices").get(engineCurrency);
}

export function transformBookableWithCurrencyConversion(
  bookable,
  engineCurrency,
  currencyExchange
) {
  const bookableCurrency = bookable.get("currency");
  const exchangeMultiplier = getExchangeMultiplier(
    bookableCurrency,
    engineCurrency,
    currencyExchange
  );
  const propertiesToTransform = [
    "averageRate",
    "totalRate",
    "discountAmount",
    "originalRate",
    "rackRate",
    "cityTax",
  ];
  let transformedBookable = bookable.set("originalRates", new Map());
  propertiesToTransform.map(property => {
    if (transformedBookable.has(property)) {
      transformedBookable = transformedBookable.setIn(
        ["originalRates", property],
        transformedBookable.get(property)
      );
      transformedBookable = transformedBookable.set(
        property,
        transformedBookable.get(property) * exchangeMultiplier
      );
    }
  });
  return transformedBookable;
}

export function calculateServiceRate({
  service,
  rooms,
  transformCurrency,
  stayRate,
  inventoryTicker,
  propertyARI,
  defaultCurrency,
  currencyExchange,
}) {
  if (!propertyARI || !inventoryTicker) {
    return 0;
  }

  const totalRatePerDay = service.get("totalRatePerDay");
  const appliesToGuests = service.get("appliesToGuests");
  const inventoryConfigurationTicker = propertyARI
    .get("inventories")
    .get(inventoryTicker)
    .get("configuration");
  const guests =
    propertyARI.get("configurations").get(inventoryConfigurationTicker) &&
    propertyARI.get("configurations").get(inventoryConfigurationTicker).get("guests");

  let dateQuantity = !(service.get("dateQuantity") instanceof Map)
    ? new Map(service.get("dateQuantity"))
    : service.get("dateQuantity");
  if (dateQuantity.size < 1) {
    dateQuantity = service.get("totalRatePerDay").map(() => 1);
  }

  let totalServiceAmountPerSpecificDay = dateQuantity
    .filter(quantity => quantity > 0)
    .slice(
      0,
      service.get("dateSelectionType") === constants.DATE_SELECTION_TYPE.NONE
        ? 1
        : dateQuantity.size
    )
    .map((quantity, date) => (totalRatePerDay.get(date) ? totalRatePerDay.get(date) : 0) * quantity)
    .reduce((totalAmount, amount) => totalAmount + amount);

  // WE USE ORIGINAL RATES BECAUSE THIS IS LATER MULTIPLIED BY THE EXCHANGE MULTIPLIER
  totalServiceAmountPerSpecificDay = transformCurrency
    ? totalServiceAmountPerSpecificDay *
      getExchangeMultiplier(service.get("currency"), defaultCurrency, currencyExchange)
    : totalServiceAmountPerSpecificDay;

  switch (service.get("type")) {
    case constants.SERVICE_TYPE.ROOM:
      return totalServiceAmountPerSpecificDay * rooms;
    case constants.SERVICE_TYPE.PERSON:
      const capacity = guests
        .filter(guest => !appliesToGuests || appliesToGuests.contains(guest.get("type")))
        .map(guest => guest.get("quantity"))
        .reduce((totalGuests, guestQuantity) => totalGuests + guestQuantity);

      return totalServiceAmountPerSpecificDay * rooms * capacity;
    case constants.SERVICE_TYPE.UNIT:
      return totalServiceAmountPerSpecificDay;
    case constants.SERVICE_TYPE.PERCENTAGE:
      return (stayRate * totalServiceAmountPerSpecificDay) / 100;
    default:
      return 0;
  }
}

/* TODO: THIS MUST BE A SELECTOR */
export function getPromotions(propertyTicker, allPromotions) {
  let result = null;

  result =
    (allPromotions &&
      allPromotions.get(propertyTicker) &&
      allPromotions
        .get(propertyTicker)
        .filter(promotion => {
          if (promotion.get("visibleInEngine")) {
            return fromJS({
              id: promotion.get("ticker"),
              name: promotion.get("name"),
              description: promotion.get("description"),
              reduction: promotion.get("reduction"),
              percentage: promotion.get("percentage"),
              startValidPeriod: new Date(promotion.get("validSince")),
              endValidPeriod: new Date(promotion.get("validUntil")),
              expires: promotion.get("expires"),
              status: promotion.get("status"),
              order: promotion.get("order"),
            });
          }
        })
        .toList()
        .sort((itemA, itemB) => sortBy(itemA, itemB, "order", false))) ||
    null;

  return result;
}

export function hexToRGBAString(hex, opacity) {
  const rColor = hex >> 16;
  const gColor = (hex >> 8) & 0xff;
  const bColor = hex & 0xff;
  const alpha = opacity || "1";
  return `rgba(${rColor}, ${gColor}, ${bColor}, ${alpha})`;
}

export function getStatusDetails(
  status,
  type,
  value,
  labelClassName,
  failedValueClassName,
  successValueClassName
) {
  if (!status) {
    return null;
  }
  return {
    status: status,
    valueType: type,
    value: value,
    labelClassName: labelClassName,
    valueClassName:
      status === constants.BOOKABLE_STATUS.AVAILABLE ? successValueClassName : failedValueClassName,
  };
}

export function evalScript({ scriptArr, cb }) {
  if (!scriptArr || scriptArr.length <= 0) {
    cb(true);
  }
  const elem = scriptArr.shift();
  const head = document.getElementsByTagName("head")[0] || document.documentElement;
  const script = document.createElement("script");

  if (elem && elem.src) {
    script.type = "text/javascript";
    script.src = elem.src;

    let done = false;
    script.onload = script.onreadystatechange = function () {
      // eslint-disable-line
      console.log("------------------ LOADED ------------------");
      if (
        !done &&
        (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")
      ) {
        done = true;
        evalScript({ scriptArr, cb });
        script.onload = script.onreadystatechange = null;
      }
    };

    head.insertBefore(script, head.firstChild);
    return null;
  }
  if (elem) {
    const data = elem.text || elem.textContent || elem.innerHTML || "";
    script.type = "text/javascript";
    script.appendChild(document.createTextNode(data));
    head.insertBefore(script, head.firstChild);
    try {
      head.removeChild(script);
      if (elem.parentNode) {
        elem.parentNode.removeChild(elem);
      }
    } catch (e) {
      console.warn("Failed to remove child", e);
    }
  }
  if (scriptArr && scriptArr.length > 0) {
    evalScript({ scriptArr, cb });
  }
}

function createNewEvent(name) {
  const event = document.createEvent("Event");

  event.initEvent(name, true, true);

  return event;
}

export function executeEvent(name) {
  const event = createNewEvent(name);

  window.dispatchEvent(event);
}

/* eslint-disable */
function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];

    // split our query string into its component parts
    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split("=");

      // in case params look like: list[]=thing1&list[]=thing2
      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function (v) {
        paramNum = v.slice(1, -1);
        return "";
      });

      if (!paramName) {
        continue;
      }

      // set parameter value (use 'true' if empty)
      var paramValue = typeof a[1] === "undefined" ? true : a[1];

      // (optional) keep case consistent
      // paramName = paramName.toLowerCase();
      // paramValue = paramValue.toLowerCase();

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === "string") {
          obj[paramName] = [obj[paramName]];
        }
        // if no array index number specified...
        if (typeof paramNum === "undefined") {
          // put the value on the end of the array
          obj[paramName].push(paramValue);
        }
        // if array index number specified...
        else {
          // put the value at that index number
          obj[paramName][paramNum] = paramValue;
        }
      }
      // if param name doesn't exist yet, set it
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
}
/* eslint-enable */

// Destination URL Params will override originURL Params
export function copyURLParams(originURL, destinationURL, requestedParams) {
  if (!destinationURL || !originURL) {
    return null;
  }
  const originParams = getAllUrlParams(originURL);
  const destinationParams = getAllUrlParams(destinationURL);
  const finalParams = {
    ...originParams,
    ...destinationParams,
    datein: moment(requestedParams.start).format("DD-MM-YYYY"),
    dateout: moment(requestedParams.end).format("DD-MM-YYYY"),
    adults: requestedParams.adults,
    children: requestedParams.children,
    guestAges: requestedParams.guestAges,
    lang: requestedParams.lang,
  };

  delete finalParams.expand;

  const baseURL = destinationURL.split("?")[0];
  let url = baseURL + "?";
  Object.keys(finalParams).forEach(param => {
    url += param + "=" + finalParams[param] + "&";
  });
  return url.slice(0, -1);
}

export function customFormObjectToString(customFormObject) {
  if (customFormObject) {
    let customFormString = "";

    Object.keys(customFormObject).forEach(key => {
      if (customFormObject[key].value) {
        let value = customFormObject[key].value;
        if (
          customFormObject[key].fieldObject &&
          customFormObject[key].fieldObject.widget === "PHONE"
        ) {
          value = `${value.prefix} ${value.number}`;
        }

        customFormString += `\n${customFormObject[key].label}: ${value}`;
      }
    });

    return customFormString;
  }
  return "";
}

function filterByTicker({ elem, activeEntity }) {
  if (
    !elem.conditions ||
    !elem.conditions.find(it => it.type === constants.DISPLAY_CONDITION_TYPE.TICKER)
  ) {
    return true;
  }
  const condition = elem.conditions.find(it => it.type === constants.DISPLAY_CONDITION_TYPE.TICKER);
  let valid = true;
  const value = condition.value || [];
  const valueToSearch = activeEntity && activeEntity.ticker;

  switch (condition.modifier) {
    case "ALL":
      break;
    case "INCLUDE":
      valid = value.indexOf(valueToSearch) >= 0;
      break;
    case "EXCLUDE":
      valid = value.indexOf(valueToSearch) <= 0;
      break;
    default:
  }
  return valid;
}

function filterByBookingWindow({ elem }) {
  if (elem.startDate && elem.endDate) {
    const today = moment();
    const start = moment(elem.startDate);
    const end = moment(elem.endDate);
    return !(today.isBefore(start) || today.isAfter(end));
  }
  return true;
}

function filterByActive({ elem }) {
  return elem.active;
}

function filterInfoByContent({ elem, activeEntity }) {
  if (!activeEntity || elem.type !== constants.DISPLAY_ELEMENT_TYPE.INFO) {
    return true;
  }

  const hasImages = activeEntity.media && activeEntity.media.length > 0;
  const hasDescription = Boolean(activeEntity.description);

  return hasImages || hasDescription;
}

function filterByEntity({ elem, activeEntity, isPropertyChain }) {
  if (
    !elem.conditions ||
    !elem.conditions.find(it => it.type === constants.DISPLAY_CONDITION_TYPE.ENTITY)
  ) {
    return true;
  }

  const condition = elem.conditions.find(it => it.type === constants.DISPLAY_CONDITION_TYPE.ENTITY);
  let valid = true;
  const value = condition.value || [];
  const valueToSearch =
    // TODO: Short circuit to show custom maps in aggrs. This is not sound, and should be cleaned when display logic is simplified.
    (isPropertyChain &&
      elem.type === "CUSTOM" &&
      elem.ticker === "map" &&
      constants.ACTIVE_ENTITY_TYPE.HOTEL) ||
    (activeEntity && activeEntity.type) ||
    (isPropertyChain && constants.ACTIVE_ENTITY_TYPE.CHAIN);

  switch (condition.modifier) {
    case "ALL":
      break;
    case "INCLUDE":
      valid = value.indexOf(valueToSearch) >= 0;
      break;
    case "EXCLUDE":
      valid = value.indexOf(valueToSearch) <= 0;
      break;
    default:
  }
  return valid;
}

function getRedirectUriDomain(mainDomain) {
  return mainDomain ? `${window.location.protocol}//${mainDomain}` : window.location.origin;
}

function getAuthUrl(authorizationServiceDomain) {
  return authorizationServiceDomain
    ? `https://${authorizationServiceDomain}/auth`
    : window.__additionalData.AUTH_URL;
}

export function filterDisplayElement({ activeEntity, isPropertyChain, type }) {
  switch (type) {
    case constants.DISPLAY_CONDITION_TYPE.BOOKING_WINDOW:
      return elem => filterByBookingWindow({ elem });
    case constants.DISPLAY_CONDITION_TYPE.ACTIVE:
      return elem => filterByActive({ elem, activeEntity, isPropertyChain });
    case constants.DISPLAY_CONDITION_TYPE.ENTITY:
      return elem => filterByEntity({ elem, activeEntity, isPropertyChain });
    case constants.DISPLAY_CONDITION_TYPE.TICKER:
      return elem => filterByTicker({ elem, activeEntity, isPropertyChain });
    case "info_content":
      return elem => filterInfoByContent({ elem, activeEntity, isPropertyChain });
    default:
      return () => true;
  }
}

export function currentCancellationPolicyRule(cancellationPolicies) {
  if (!cancellationPolicies) {
    return {};
  }

  const sortedCancellationPolicies = cancellationPolicies.sort((left, right) =>
    left.hasOwnProperty("minRelease") ? -1 : right.hasOwnProperty("minRelease") ? 1 : 0
  );
  return (
    (Array.isArray(sortedCancellationPolicies) &&
      sortedCancellationPolicies.find(policy => {
        const date = moment(new Date());
        let minRelease;
        if (policy.minRelease && policy.minReleaseTimeLimit && policy.minReleaseTimeZone) {
          minRelease = moment(`${policy.minRelease} ${policy.minReleaseTimeLimit}`).utcOffset(
            policy.minReleaseTimeZone
          );
          return date.isSame(minRelease) || date.isBefore(minRelease);
        } else {
          return date.isAfter(minRelease) && date.isBefore(policy.maxRelease);
        }
      })) ||
    {}
  );
}

export function removeUndefinedOrNullProps(obj) {
  if (!obj || Object.prototype.toString.call(obj) !== "[object Object]") {
    return obj;
  }
  return Object.entries(obj).reduce(
    (acc, [key, val]) => (val === undefined || val === null ? acc : { ...acc, [key]: val }),
    {}
  );
}
export function getCityTaxConfiguration(channel, affiliate) {
  return channel === constants.CHANNEL.GOOGLE || affiliate === constants.CHANNEL.GOOGLE
    ? constants.CITY_TAX_CONFIGURATION.EXCLUDE_BEFORE_CHECKOUT
    : constants.CITY_TAX_CONFIGURATION.EXCLUDE_FROM_ALL_STEPS;
}

export function handleGallery(handleModalContent, handleGallery) {
  return (element, title, description, ticker, extraAction, type, event, infoOnly) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!element || element.length < 1) {
      handleModalContent(
        <div>
          <h1 className="wbkv9-Modal-roomTitle">{title}</h1>
          <div dangerouslySetInnerHTML={renderHTML(description)} />
        </div>
      );
    }

    let callback = null;
    if (element) {
      handleGallery(
        element,
        title,
        description,
        {
          bgOpacity: 0.85,
          index: 0,
          preload: [1, 1],
        },
        { ticker, callback },
        extraAction,
        type,
        infoOnly
      );
    }
  };
}

export function decorateUrl(urlString) {
  const ga = window[window["GoogleAnalyticsObject"]];
  if (ga && typeof ga.getAll === "function") {
    const tracker = ga.getAll()[0]; // Uses the first tracker created on the page
    return window.gaplugins ? new window.gaplugins.Linker(tracker).decorate(urlString) : urlString;
  }
  return urlString;
}

export function redirectUrl(urlString) {
  window.location.href = decorateUrl(urlString);
}

export function redirectOpenerUrl(urlString) {
  window.opener.location.href = decorateUrl(urlString);
}

export function redirectTopUrl(urlString) {
  window.top.location.href = decorateUrl(urlString);
}

export function getAnalyticsParams() {
  let gtmCodes = [window.__additionalData.WITBOOKING_GTM_CODE];
  if (window.__additionalData.CLIENT_GTM_CODES) {
    gtmCodes = gtmCodes.concat(window.__additionalData.CLIENT_GTM_CODES).join(",");
  }
  let clientGACodes = [];
  if (window.__additionalData.CLIENT_GA_CODES) {
    clientGACodes = clientGACodes.concat(window.__additionalData.CLIENT_GA_CODES).join(",");
  }
  let clientGADomains = ["witbooking.com"];
  if (window.__additionalData.CLIENT_GA_DOMAINS) {
    clientGADomains = clientGADomains.concat(window.__additionalData.CLIENT_GA_DOMAINS).join(",");
  }
  return { gtmCodes, clientGACodes, clientGADomains };
}

export function saveDeferredReservationToLocalStorage(propertyTicker, reservationId) {
  if (!propertyTicker || !reservationId) {
    return;
  }
  let deferredReservationsList = getFromLocalStorage(
    constants.LOCAL_STORAGE_KEYS.DEFERRED_RESERVATION_ID
  );
  deferredReservationsList = deferredReservationsList
    ? JSON.parse(deferredReservationsList)
    : {
        [propertyTicker]: [],
      };
  if (!deferredReservationsList[propertyTicker]) {
    deferredReservationsList[propertyTicker] = [];
  }
  if (deferredReservationsList[propertyTicker].includes(reservationId)) {
    return;
  }
  deferredReservationsList[propertyTicker].push(reservationId);
  saveToLocalStorage(
    constants.LOCAL_STORAGE_KEYS.DEFERRED_RESERVATION_ID,
    JSON.stringify(deferredReservationsList)
  );
}

export function isDeferredReservationInLocalStorage(propertyTicker, reservationId) {
  if (!propertyTicker || !reservationId) {
    return false;
  }
  let deferredReservationsList = getFromLocalStorage(
    constants.LOCAL_STORAGE_KEYS.DEFERRED_RESERVATION_ID
  );
  if (!deferredReservationsList) {
    return false;
  }
  deferredReservationsList = JSON.parse(deferredReservationsList);
  if (!deferredReservationsList[propertyTicker]) {
    return false;
  }
  return deferredReservationsList[propertyTicker].includes(reservationId);
}

export function removeDeferredReservationFromLocalStorage(propertyTicker, reservationId) {
  if (!propertyTicker || !reservationId) {
    return;
  }
  let deferredReservationsList = getFromLocalStorage(
    constants.LOCAL_STORAGE_KEYS.DEFERRED_RESERVATION_ID
  );
  if (!deferredReservationsList) {
    return;
  }
  deferredReservationsList = JSON.parse(deferredReservationsList);
  if (
    !deferredReservationsList[propertyTicker] ||
    !deferredReservationsList[propertyTicker].includes(reservationId)
  ) {
    return;
  }
  deferredReservationsList[propertyTicker] = deferredReservationsList[propertyTicker].filter(
    it => it !== reservationId
  );
  saveToLocalStorage(
    constants.LOCAL_STORAGE_KEYS.DEFERRED_RESERVATION_ID,
    JSON.stringify(deferredReservationsList)
  );
}

function getEncodedQueryParams(params) {
  const uri = Object.entries(params)
    .filter(it => !!it[1])
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return encodeURIComponent(`?${uri}`);
}

export function getLinkToLoyaltyLogin({
  brand,
  propertyTicker,
  locale,
  queryParams,
  bookingFormInitialValues,
}) {
  if (brand) {
    const redirectUriDomain = getRedirectUriDomain(brand.mainDomain);
    const analyticsParams = getAnalyticsParams();
    const authUrl = getAuthUrl(brand.authorizationServiceDomain);
    const occupants = {
      adults: bookingFormInitialValues[constants.OCCUPANTS_TYPE.ADULT] ?? 0,
      seniors: bookingFormInitialValues[constants.OCCUPANTS_TYPE.SENIOR],
      teenagers: bookingFormInitialValues[constants.OCCUPANTS_TYPE.TEENAGER],
      babies: bookingFormInitialValues[constants.OCCUPANTS_TYPE.BABY],
    };
    const queryParamsWithOccupants = { ...occupants, ...queryParams };
    return decorateUrl(
      `${authUrl}/realms/${brand.ticker}/protocol/openid-connect/auth` +
        `?response_type=code` +
        `&client_id=${window.__additionalData.AUTH_CLIENT_ID}` +
        `&embedded=false` +
        `&scope=openid` +
        `&redirect_uri=${redirectUriDomain}/api/loyalty/${brand.ticker}/${propertyTicker}/session` +
        `${getEncodedQueryParams(queryParamsWithOccupants)}` +
        `&property_ticker=${propertyTicker}` +
        `&ui_locales=${locale}` +
        `&gtmCodes=${analyticsParams.gtmCodes}` +
        `&analyticsCodes=${analyticsParams.clientGACodes}` +
        `&analyticsDomains=${analyticsParams.clientGADomains}` +
        `&brandTicker=${brand.ticker}`
    );
  }
}

export function getLinkToLoyaltyLoginWithSessionId({
  brand,
  propertyTicker,
  locale,
  sessionId,
  customerId,
  origin,
}) {
  if (brand) {
    const analyticsParams = getAnalyticsParams();
    const authUrl = getAuthUrl(brand.authorizationServiceDomain);
    const redirectUriDomain = getRedirectUriDomain(brand.mainDomain);
    const baseDomainUrl = `${redirectUriDomain}/api/loyalty/${brand.ticker}/${propertyTicker}`;
    const redirectUri = `${baseDomainUrl}/session/${sessionId}/customer/${customerId}`;
    return decorateUrl(
      `${authUrl}/realms/${brand.ticker}/protocol/openid-connect/auth` +
        `?response_type=code` +
        `&client_id=${window.__additionalData.AUTH_CLIENT_ID}` +
        `&scope=openid` +
        `&redirect_uri=${redirectUri}` +
        `&property_ticker=${propertyTicker}` +
        `&ui_locales=${locale}` +
        `&gtmCodes=${analyticsParams.gtmCodes}` +
        `&analyticsCodes=${analyticsParams.clientGACodes}` +
        `&analyticsDomains=${analyticsParams.clientGADomains}` +
        `&brandTicker=${brand.ticker}` +
        `&origin=${origin}`
    );
  }
}
